<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class=""
     [hidden]="displayMode === 'view' || orgId !== ''">
    <div class="d-flex mb-5">
        <button class="btn btn-info ml-auto btn-size-normal"
                [routerLink]="['./', 'add-users']">
            <span class="btn-inner--text"
                  i18n>Assign User(s)</span>
        </button>
    </div>
</div>

<app-data-table-ajax #dataTableAjax
                     *ngIf="roleId"
                     [url]="dataTableUrl"
                     limit="25"
                     [columns]="columns"
                     [displaySearch]="this.displayMode !== 'view'"
                     [rowHeight]="undefined"
                     (rowClicked)="onSelectRow($event)">
    <ng-template #actionTemplate
                 let-row="row">
        <button i18n
                type="button"
                class="btn btn-link p-0 m-0 mr-3"
                (click)="onEditClick(row, $event)">
            <img alt="Manage User Scope"
                 title="Manage User Scope"
                 class="row-icon"
                 src="assets/_ionicons_svg_md-list-box.svg" />
        </button>
        <button i18n
                type="button"
                class="btn btn-link p-0 m-0"
                (click)="onRemoveRow(row , $event)"><img alt="Remove From Role"
                 title="Remove From Role"
                 class="row-icon"
                 src="assets/_ionicons_svg_md-trash.svg"></button>
    </ng-template>

    <ng-template #scopesTpl
                 let-row="row">
        <div class="scopes-column">
            <div class="text-capitalize "
                 *ngFor="let item of scopeFormat(row.scopes)">
                {{ item }}
            </div>
        </div>
    </ng-template>
    <ng-template #nameTemplate
                 let-row="row">
        {{ row.firstname }} {{ row.lastname }}
    </ng-template>
</app-data-table-ajax>


// WEBPACK FOOTER //
// ./src/app/access-management/roles/role-users-table/role-users-table.component.html